import React from "react";
import g from "glamorous";
import { css } from "glamor";
import Link from "gatsby-link";

class PreviewLink extends React.Component {
  render() {
    return (
          <a href={this.props.to} className="previewLink" target={this.props.target}>
              <g.Img src={this.props.img} style={{marginBottom:0, width:this.props.w}} alt={this.props.alt}/>
                <br/>    
              <g.Span color="#666" className="genre">{this.props.title}</g.Span><br/>
                {this.props.text}<br/>
          </a>
    )
  }
}
module.exports = PreviewLink;


// WEBPACK FOOTER //
// ./src/templates/preview-link.js